import {
    AdUnitType,
    AppState,
    campaignCreativesForm,
    campaignCreativesFormBindings,
    setAdUnitTypeAction
} from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { AccordionCardComponent } from "./AccordionCard";
import { AdUnitBuilder, AdUnitInfo } from "./adunit-builder";
import "./CampaignCreativesPlanForm.css";
import { AdUnitTypesComponent } from "./campaignForm/AdUnitTypesComponent";
import { Fieldset } from "./Fieldset";
import { Tour } from "./tour";

export interface CampaignCreativesPlanFormComponentProps {
    formData: typeof campaignCreativesForm.types.selectorResult;
    formEvents: typeof campaignCreativesForm.types.eventBindings;
    adTypes: AdUnitType[];
    selectedFormat: string;
    onSetAdUnitType: (adUnitType: string) => void;
}

export interface CampaignCreativesPlanFormComponentState {}

export class CampaignCreativesPlanFormComponent extends React.Component<
    CampaignCreativesPlanFormComponentProps,
    CampaignCreativesPlanFormComponentState
> {
    constructor(props: CampaignCreativesPlanFormComponentProps) {
        super(props);
    }

    render() {
        const { formData: form, formEvents: events, adTypes, selectedFormat } = this.props;

        return (
            <form {...events.form}>
                <AccordionCardComponent
                    cardHeader="Creatives"
                    bodyClassName="creatives-creatives tour-campaign-ad-unit-types"
                    isOpen={true}
                >
                    <div className="creatives-item creatives-types-wrapper">
                        <AdUnitTypesComponent
                            value={form.fields.adUnitType.value}
                            onChange={events.fields.adUnitType.onChange}
                            adTypes={adTypes}
                            events={events}
                        />
                    </div>
                </AccordionCardComponent>

                <AccordionCardComponent cardHeader="Ad Unit" bodyClassName="creatives-adunit" isOpen={true}>
                    <AdUnitBuilder />
                </AccordionCardComponent>
                <AccordionCardComponent
                    cardHeader="Ad Unit Preview"
                    bodyClassName="creatives-adunit-preview tour-campaign-adunit-preview"
                    isOpen={true}
                >
                    <AdUnitInfo selectedFormat={selectedFormat} />
                </AccordionCardComponent>

                <AccordionCardComponent
                    cardHeader="Additional trackings"
                    bodyClassName="creatives-tracking-interaction tour-campaign-adunit-additional-tracking"
                    isOpen={true}
                >
                    <div className="interaction-wrapper">
                        <div className="interaction-input-wrapper">
                            <Fieldset
                                className="interaction-custom-fieldset"
                                label="Impression Tracking URL 1"
                                errorMessage={form.fields.impressionTrackingUrl1}
                            >
                                <input
                                    type="text"
                                    name=""
                                    id=""
                                    value={form.fields.impressionTrackingUrl1.value || ""}
                                    {...events.fields.impressionTrackingUrl1}
                                />
                            </Fieldset>
                            <Fieldset
                                label="Impression Tracking URL 2"
                                errorMessage={form.fields.impressionTrackingUrl2}
                            >
                                <input
                                    type="text"
                                    name=""
                                    id=""
                                    value={form.fields.impressionTrackingUrl2.value || ""}
                                    {...events.fields.impressionTrackingUrl2}
                                />
                            </Fieldset>
                        </div>
                        <Fieldset
                            className="Fieldset__textarea"
                            label="Tracking tags"
                            errorMessage={form.fields.trackingTags}
                        >
                            <textarea
                                className="interaction-textarea"
                                name=""
                                id=""
                                placeholder="Paste HTML tag..."
                                value={form.fields.trackingTags.value || ""}
                                {...events.fields.trackingTags}
                            />
                        </Fieldset>
                    </div>
                </AccordionCardComponent>
                <Tour isRunning tour="campaign-creatives" />
            </form>
        );
    }
}

export interface CampaignCreativesPlanFormProps {}

export const CampaignCreativesPlanForm = connect(
    (state: AppState, ownProps: CampaignCreativesPlanFormProps): Partial<CampaignCreativesPlanFormComponentProps> => {
        const selectedFormat = state.campaignState.campaignMediaPlanForm.fields.adUnitFormat;

        let adTypes: AdUnitType[] =
            FetchingState.isSuccess(state.mappings.adunits) &&
            selectedFormat &&
            state.mappings.adunits.data.filter(format => format.size === selectedFormat)[0].types;

        adTypes = adTypes && adTypes.filter(type => type.isSupportedByAdUnitBuilder);

        return {
            formData: campaignCreativesForm.selector(state.campaignState.campaignCreativesForm),
            adTypes: adTypes || [],
            selectedFormat
        };
    },
    (dispatch: Dispatch): Partial<CampaignCreativesPlanFormComponentProps> => ({
        formEvents: campaignCreativesFormBindings.bind(dispatch, undefined),
        onSetAdUnitType: (adUnitType: string) => {
            dispatch(setAdUnitTypeAction({ adUnitType: adUnitType }));
        }
    })
)(CampaignCreativesPlanFormComponent);
